import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InspectionManagerModalService {

  private selectedInspectionSubject = new BehaviorSubject<any>(null);
  public selectedInspection$ = this.selectedInspectionSubject.asObservable();

  private preSelectedVehicleSubject = new BehaviorSubject<any>(null);
  public preSelectedVehicle$ = this.preSelectedVehicleSubject.asObservable();

  constructor() { }

  setSelectedInspection(inspection: any): void {
    this.selectedInspectionSubject.next(inspection);
  }

  getSelectedInspection(): any | null {
    return this.selectedInspectionSubject.value;
  }

  clearSelectedInspection(): void {
    this.selectedInspectionSubject.next(null);
  }

  setPreSelectedVehicle(vehicle: any): void {
    this.preSelectedVehicleSubject.next(vehicle);
  }

  getPreSelectedVehicle(): any | null {
    return this.preSelectedVehicleSubject.value;
  }

  clearPreSelectedVehicle(): void {
    this.preSelectedVehicleSubject.next(null);
  }
}
